<template>
  <div
    v-if="isVisible"
    class="fe-fixed fe-top-0 fe-left-0 fe-h-full fe-w-full fe-overflow-auto fe-z-[100] fe-flex"
  >
    <div
      class="fe-fixed fe-top-0 fe-left-0 fe-bottom-0 fe-w-full fe-z-[60] fe-bg-primary-grey-80 fe-transition fe-ease-rapid fe-duration-medium"
      @click="handleClose"
    ></div>
    <div
      class="fe-w-full fe-max-w-[584px] fe-max-h-[80vh] sm:fe-mt-auto lg:fe-m-auto fe-flex fe-relative fe-z-[60] fe-bg-primary-background fe-transition fe-ease-rapid fe-duration-medium sm:fe-rounded-t-xl lg:fe-rounded-xxl fe-shadow-m"
      @click.stop
    >
      <div class="fe-flex fe-flex-col fe-p-m fe-w-full fe-h-auto">
        <div
          class="fe-flex fe-items-center fe-justify-between fe-text-heading-xs"
          v-if="$slots.header"
        >
          <div>
            <slot name="header"></slot>
          </div>
          <div class="fe-flex lg:fe-justify-end sm:fe-order-1">
            <JdsButton
              @click="handleClose"
              :iconOnly="true"
              size="small"
              variant="tertiary"
            >
              <template #icon>
                <JdsIcon name="CloseIcon" size="m" color="fe-text-primary-60" />
              </template>
            </JdsButton>
          </div>
        </div>
        <div class="fe-flex fe-flex-col fe-flex-1 fe-overflow-y-auto">
          <slot name="body"></slot>
        </div>
        <div class="fe-w-full fe-pt-base" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"

  export default {
    name: "JdsDialog",
    components: {
      JdsButton,
      JdsIcon,
    },
    props: {
      // This prop is must for Vue to track the component reactivity. But we don't want to create any new state variable to track this value in most of the cases, because the way we have designed ModalRegistry component. So that's why we have kept the default value as TRUE.
      isVisible: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      handleClose() {
        this.$emit("close")
      },
    },
  }
</script>
